export default __webpack_public_path__ + "audio/52feab03f0709c93df588194dfef3abf-helicopterStrike.wav";